import React from 'react'
import NumberInput from './NumberInput'
import styles from './DesignFlow.module.css'
import styles2 from './s.module.css'

const DesignFlow = ({label, value, onChange}) => {
  return (
    <div className={styles2.dimItemContainer}>
      <label>{label}</label>
      <NumberInput value={value} className={styles.designFlowInput}
        onChange={onChange} />
    </div>
  )
}

// DesignFlow.propTypes = {
//   label: PropTypes.string,
//   value: PropTypes.number,
//   onChange: PropTypes.func
// }

export default DesignFlow
